"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DualFlag = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _faArrowRight = require("@fortawesome/pro-solid-svg-icons/faArrowRight");
var _Flag = require("./Flag");
var _DualFlag = require("./DualFlag.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArrowColor = /*#__PURE__*/function (ArrowColor) {
  ArrowColor["WHITE"] = "rgba(255, 255, 255, 0.5)";
  ArrowColor["LIGHT"] = "rgba(72, 72, 72, 0.5)";
  ArrowColor["DARK"] = "#484848";
  return ArrowColor;
}(ArrowColor || {});
var DualFlag = function DualFlag(props) {
  var arrowStyling = {
    margin: props.arrowMargin ? "0 ".concat(props.arrowMargin, "px ").concat(props.startFlag.showCodeLabel ? '20px' : '0') : "0 11px ".concat(props.startFlag.showCodeLabel ? '20px' : '0'),
    width: props.arrowWidth ? props.arrowWidth : 16,
    height: props.arrowHeight ? props.arrowHeight : 16,
    color: props.arrowColor ? ArrowColor[props.arrowColor] : ArrowColor.LIGHT
  };
  var classes = (0, _DualFlag.useStyles)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_Flag.Flag, props.startFlag), /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faArrowRight.faArrowRight,
    style: arrowStyling
  }), /*#__PURE__*/_react["default"].createElement(_Flag.Flag, props.endFlag)));
};
exports.DualFlag = DualFlag;